// removed by extract-text-webpack-plugin
module.exports = {"profile":"src-modules-settings-PaymentsSettingsView-__CompanyPaymentProfileRelationFormSection__profile--2Tptj","profile-select":"src-modules-settings-PaymentsSettingsView-__CompanyPaymentProfileRelationFormSection__profile-select--1F4qJ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/settings/PaymentsSettingsView/CompanyPaymentProfileRelationFormSection.less
// module id = 1896
// module chunks = 0